import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SfoUiJSONSchema7 } from '../../../metadata.model';

import { SfoAdmonitionComponent } from '../../../widgets/admonition/admonition.component';
import { DynamicFieldComponent } from '../../form-fields/dynamic-field.component';
import { MarkdownPipe } from '../../markdown.pipe';

@Component({
  selector: 'drawer-view-content',
  templateUrl: './drawer-view-content.component.html',
  imports: [SfoAdmonitionComponent, DynamicFieldComponent, MarkdownPipe],
})
export class DrawerViewContentComponent {
  @Input() control: string = '';
  @Input() schema: SfoUiJSONSchema7 | null;
  @Input() aFormControl: FormGroup | null;
}
